import { QueryClient } from '@tanstack/vue-query'
import { ApiError } from './api'

/**
 * Shared query client: logout clears it, so the next account never sees the
 * previous one's data. A 4xx is an answer, not a failure: it is not retried.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchOnWindowFocus: true,
      retry: (failures, error) =>
        failures < 1 && !(error instanceof ApiError && error.status >= 400 && error.status < 500),
    },
  },
})
